import { z } from 'zod'
import { CourtesyStatus } from '~library/enums'
import {
  applyFlightSchema,
  dateValueSchema,
  managerBenefitCommonSchema
} from '~library/models'

/** 套裝子項目清單 Schema */
export const suitCourtesySchema = z.object({
  /** 分類 */
  type: z.string(),
  /** 券號 */
  couponNo: z.string(),
  /** 使用起始時間 */
  useStartTime: z.string(),
  /** 使用截止時間 */
  useEndTime: z.string(),
  /** 禮遇安排日期 */
  arrangementTime: z.string(),
  /** 狀態 */
  status: z.string(),
  /** 出發時間 */
  departureTime: z.string()
})

/** 取得禮遇歷史紀錄清單 - 資料 Schema */
export const benefitAndVoucherManagementGetHistoryListSchema = z
  .object({
    /** 指派禮遇Id */
    id: z.string(),
    /** 券號 */
    couponNo: z.string(),
    /** 狀態 */
    status: z.nativeEnum(CourtesyStatus),
    /** 使用起始時間 */
    useStartTime: dateValueSchema,
    /** 使用截止時間 */
    useEndTime: dateValueSchema,
    /** 禮遇安排日期 */
    arrangementTime: dateValueSchema,
    /** 訂位代號 */
    pnr: z.string(),
    /** 優惠碼 */
    promoCode: z.string(),
    /** 出發時間 */
    departureTime: z.string(),
    /** 套裝子項目清單 */
    suitCourtesy: z.array(suitCourtesySchema),
    /** 使用航段資訊 */
    applyFlight: z.array(applyFlightSchema)
  })
  .merge(managerBenefitCommonSchema)

/** 取得禮遇歷史紀錄清單 - 資料 */
export interface BenefitAndVoucherManagementGetHistoryList
  extends z.infer<typeof benefitAndVoucherManagementGetHistoryListSchema> {}
